import {
  Grid,
  InputAdornment,
  Slider,
  Stack,
  styled,
  Typography
} from "@mui/material";
import { useState } from "react";
import { StyledButton } from "../../pages/gift-card/GiftCard";
import { extraordinaryColors } from "../../utils/theme";
import { StyledTextField } from "../ContactForm";

const StyledSlider = styled(Slider)(() => ({
  color: extraordinaryColors.purple.main,
  height: 18,
  "& .MuiSlider-thumb": {
    width: 22,
    height: 22,
    backgroundColor: "currentColor",
    boxShadow: "none",
    "&:hover, &.Mui-focusVisible": {
      boxShadow: "none"
    }
  },
  "& .MuiSlider-track": {
    height: 18
  },
  "& .18-rail": {
    height: 18
  }
}));

export const ContributionCalculator = () => {
  const [error, setError] = useState("");
  const [employeeCount, setEmployeeCount] = useState<number | undefined>(
    undefined
  );
  const [spend, setSpend] = useState<number | undefined>(undefined);
  const [utilisation, setUtilisation] = useState<number>(80);
  const [total, setTotal] = useState<number | undefined>();

  const handleResults = () => {
    if (!employeeCount) {
      setError("Employee count is required.");
      return;
    } else {
      setError("");
    }

    if (!employeeCount || employeeCount === 0) {
      setError("Number of Employees must be more than 0");
      return;
    } else {
      setError("");
    }

    if (!spend || spend === 0) {
      setError("Annual benefit amount per employee");
      return;
    } else {
      setError("");
    }

    const result = spend * employeeCount * (utilisation / 100);
    setTotal(result);
  };

  return (
    <>
      <Grid item sm={12} md={6} textAlign="left">
        <Typography fontWeight={700} fontSize="20px" my={1}>
          Number of Employees
        </Typography>
        <StyledTextField
          variant="standard"
          backgroundcolor="white"
          fullWidth
          textcolor={extraordinaryColors.purple.main}
          value={employeeCount}
          type="number"
          onChange={(e) => setEmployeeCount(+e.target.value)}
          name="employeeCount"
          placeholder="Employee Count"
          size="small"
          InputProps={{
            disableUnderline: true
          }}
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item sm={12} md={6} textAlign="left">
        <Typography fontWeight={700} fontSize="20px" my={1}>
          Annual benefit amount per employee
        </Typography>
        <StyledTextField
          variant="standard"
          backgroundcolor="white"
          fullWidth
          textcolor={extraordinaryColors.purple.main}
          value={spend}
          type="number"
          onChange={(e) => setSpend(+e.target.value)}
          name="spend"
          placeholder="Annual benefit amount per employee"
          size="small"
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <InputAdornment position="start">
                <Typography
                  sx={{
                    color: extraordinaryColors.purple.main,
                    fontSize: 25,
                    fontWeight: 700,
                    fontFamily: "GT-Alpina-Condensed",
                    paddingBottom: 0.5
                  }}
                >
                  $
                </Typography>
              </InputAdornment>
            )
          }}
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} textAlign="left">
        <Typography fontWeight={700} fontSize="20px">
          Utilisation Rate
        </Typography>
        <Typography fontWeight={600} fontSize="14px">
          How much you expect your employees to spend
        </Typography>
        <Typography fontWeight={600} fontSize="14px">
          (we expect to see utilisation above 80% on a plan with no
          restrictions)
        </Typography>
        <Stack spacing={2} direction="row" sx={{ alignItems: "center", my: 1 }}>
          <Typography mr={1} fontWeight={700}>
            50%
          </Typography>
          <StyledSlider
            value={utilisation}
            min={50}
            max={100}
            step={1}
            valueLabelDisplay="auto"
            onChange={(event: Event, newValue: number | number[]) =>
              setUtilisation(newValue as number)
            }
          />
          <Typography ml={1} fontWeight={700}>
            100%
          </Typography>
        </Stack>
      </Grid>

      <Grid item xs={12} md={6} textAlign="left">
        <StyledButton
          backgroundcolor={extraordinaryColors.purple.main}
          onClick={() => handleResults()}
          sx={{ marginTop: { sm: 0, md: 4.5 } }}
        >
          {!total ? "Calculate" : "Re-calculate"}
        </StyledButton>

        {error && (
          <Typography color="error" fontWeight={600} mt={2}>
            {error}
          </Typography>
        )}
      </Grid>

      <Grid item xs={12} md={3} textAlign="left" ml="auto">
        <Typography fontWeight={700} fontSize="20px" mb={1}>
          Total
        </Typography>
        <StyledTextField
          variant="standard"
          backgroundcolor="white"
          fullWidth
          textcolor={extraordinaryColors.purple.main}
          value={total}
          type="number"
          name="total"
          placeholder="Total"
          size="small"
          disabled={true}
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <InputAdornment position="start">
                <Typography
                  sx={{
                    color: extraordinaryColors.purple.main,
                    fontSize: 25,
                    fontWeight: 700,
                    fontFamily: "GT-Alpina-Condensed",
                    paddingBottom: 0.5
                  }}
                >
                  $
                </Typography>
              </InputAdornment>
            )
          }}
          sx={{ my: 1 }}
        />
      </Grid>
    </>
  );
};
